"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const users_1 = require("../../utils/users");
const api_1 = __importDefault(require("../api"));
const setAuthorization = () => {
    const accessToken = (0, users_1.getAccessToken)();
    if (accessToken && accessToken.trim().length > 0) {
        api_1.default.defaults.headers.authorization = `Bearer ${accessToken}`;
    }
};
const CheckinService = {
    loadCheckinData: (checkinRequest) => __awaiter(void 0, void 0, void 0, function* () {
        setAuthorization();
        const response = yield api_1.default.post(`/precheckin/data`, checkinRequest);
        return response.data;
    }),
    putPreCheckin: (checkinRequest) => __awaiter(void 0, void 0, void 0, function* () {
        setAuthorization();
        const response = yield api_1.default.put(`/precheckin/update`, checkinRequest);
        return response.data;
    }),
};
exports.default = CheckinService;
